import React from 'react'

export function H1({ children }: React.PropsWithChildren<unknown>): React.ReactElement {
	return <h1 className="text-xl font-bold mb-8">{children}</h1>
}
